var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bin",staticStyle:{"padding":"5% 15%"}},[_c('h2',[_vm._v(" "+_vm._s(_vm.$t("tbc"))+" Any useful or useless garbage will be dumped here 任何有用的或是无用的垃圾将会倾倒于此 ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }